export default __webpack_public_path__ + "static/media/m_use_action_back_xw.7f91eaf7.png";